// extracted by mini-css-extract-plugin
module.exports = {"Header":"UserPriceListModal_Header__2F1Yf","Description":"UserPriceListModal_Description__1Wjs2","Table":"UserPriceListModal_Table__1Tw_n"};